module.exports = ".cote {\r\n\theight: 600px;\r\n\toverflow: scroll;\r\n\tbackground-color: var(--api-jaune);\r\n\tcolor: black;\r\n\tborder-left: solid var(--api-gris);\r\n\tfont-size: 80%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/cote/cote.component.css
// module id = ./src/app/cote/cote.component.css
// module chunks = main